import React from 'react';
import Page, { PageContentBodyGrid } from './Shared/Page/Page';
import PageGridItem from './Shared/Page/PageGridItem';
import logoBlack from '../images/3SKYE-logo-black.png'
import FlexWrapper from './FlexWrapper';
import "./NoPermissionsPage.scss";

const NoPermissionsPage = ({ errorHeader, errorMessage }) => {
	return (
		<Page noBanner>
			<PageContentBodyGrid id="error-message" style={{ gridTemplateRows: "1fr" }}>
				<PageGridItem style={{ height: "100%" }} colSpan="12">
					<FlexWrapper align="center" justify="center" direction="column" fullWidth style={{ height: "100%" }}>
						<img className='logo-black-dimenssions' src={logoBlack} alt="3skye logo" />
						<h1 className='welcome'>{errorHeader ? errorHeader : "Welcome"}</h1>
						<p className='p-message'>{errorMessage ? errorMessage : "You currently have no permissions to view this site. Please contact your software support."}</p>
					</FlexWrapper>
				</PageGridItem>
			</PageContentBodyGrid>
		</Page>
	);
}
export default NoPermissionsPage;